import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-204">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-205" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-206">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-6 text-brand-cream" data-id="element-207">
          L'Offerta <span className="text-brand-orange" data-id="element-208">"Lettere Pronte"</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1a0f0a] to-[#120a06] border border-brand-orange/40 rounded-3xl relative shadow-[0_0_50px_rgba(249,115,22,0.15)]" data-id="element-209">
          {/* Badge */}
          <div className="flex justify-center -mt-4 mb-2" data-id="element-210">
            <div className="bg-gradient-to-b from-brand-gold to-amber-500 text-black font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(251,191,36,0.5)]" data-id="element-211">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-212" />
              LA SCELTA PIÙ POPOLARE
            </div>
          </div>

          <div className="p-6 sm:p-8" data-id="element-213">
            <h3 className="text-base sm:text-lg font-black text-center text-brand-cream uppercase mb-5 leading-tight" data-id="element-214">
              VALORE TOTALE DEI CONTENUTI:
            </h3>

            <div className="space-y-0 mb-5" data-id="element-215">
              {[{
              label: 'Percorso 6 Tomi (Medie e Superiori)',
              price: '197€'
            }, {
              label: 'Verifiche, Rubriche e Materiale LIM',
              price: '67€'
            }, {
              label: 'Kit Recupero e Inclusione BES/DSA',
              price: '57€'
            }, {
              label: '4 Bonus Esclusivi',
              price: '87€'
            }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-white/10 py-3 gap-3" data-id="element-216">
                  <span className="text-gray-300 font-medium text-sm sm:text-base" data-id="element-217">
                    {item.label}
                  </span>
                  <span className="text-gray-500 line-through text-sm sm:text-base shrink-0" data-id="element-218">
                    {item.price}
                  </span>
                </div>)}
              <div className="flex justify-between items-center pt-4" data-id="element-219">
                <span className="text-base sm:text-lg font-black text-brand-cream uppercase" data-id="element-220">
                  VALORE REALE:
                </span>
                <span className="text-xl sm:text-2xl font-black text-brand-danger line-through" data-id="element-221">
                  408,00€
                </span>
              </div>
            </div>

            {/* Inner offer card */}
            <div className="bg-[#1f110a] border border-brand-orange/40 rounded-2xl p-5 text-center mb-5" data-id="element-222">
              <div className="inline-block bg-brand-danger/20 border border-brand-danger/40 text-brand-danger text-[11px] font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-223">
                95% di sconto — Offerta Lancio
              </div>
              <p className="text-gray-500 line-through text-base mb-1" data-id="element-224">
                408,00€
              </p>
              <div className="flex justify-center items-end gap-1 mb-1" data-id="element-225">
                <span className="text-4xl sm:text-5xl font-black text-brand-orange leading-none" data-id="element-226">
                  27,90€
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-2" data-id="element-227">
                💳 Pagamento unico • ⚡ Accesso immediato
              </p>
            </div>

            {/* Salirà presto pill */}
            <div className="flex justify-center mb-5" data-id="element-228">
              <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full" data-id="element-229">
                <ShieldCheckIcon className="w-4 h-4 text-brand-orange" data-id="element-230" />
                <span className="text-xs font-bold text-brand-orange" data-id="element-231">
                  ⏰ Prezzo speciale di lancio — salirà a breve
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44566018293895:1" className="w-full mb-5" data-id="element-232">
              SÌ! VOGLIO IL KIT COMPLETO — €27,90
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-233">
              <span className="flex items-center gap-1" data-id="element-234">
                <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-235" /> Accesso
                immediato
              </span>
              <span className="text-gray-600" data-id="element-236">•</span>
              <span className="flex items-center gap-1" data-id="element-237">
                <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-238" /> Un solo
                Pagamento
              </span>
              <span className="text-gray-600" data-id="element-239">•</span>
              <span className="flex items-center gap-1" data-id="element-240">
                <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-241" /> Garanzia
                14 giorni
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}